import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { Icon } from "../atoms";
import { Theme } from "@theme";
import { useTheme } from "@react-navigation/native";

export const AddButton = ({ onPress }: { onPress: () => void }) => {
  const theme = useTheme();
  const styles = getStyle(theme);

  return (
    <TouchableOpacity onPress={onPress} style={styles.addCategoryButton}>
        <Icon name="plus" size={theme.iconSize.large} color={theme.colors.secondary} />
      </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
    StyleSheet.create({
      addCategoryButton: {
        borderRadius: 20,
        backgroundColor: theme.colors.primary + 20,
        padding: theme.spacing.xs,
      },
})
